export const PARTNER_STATUS_VALUES = {
  LIVE: 'live',
  PENDING: 'pending',
  REJECTED: 'rejected',
};

export const PARTNER_STATUS_FILTERS = [
  { value: PARTNER_STATUS_VALUES.LIVE, label: 'Live' },
  { value: PARTNER_STATUS_VALUES.PENDING, label: 'Pending' },
  { value: PARTNER_STATUS_VALUES.REJECTED, label: 'Rejected' },
];

const PARTNER_STATUS_SET = new Set(Object.values(PARTNER_STATUS_VALUES));

export const PARTNER_STATUS_STYLES = {
  [PARTNER_STATUS_VALUES.LIVE]: {
    label: 'Live',
    chipBackgroundColor: 'rgba(46, 125, 50, 0.12)',
    chipColor: '#2e7d32',
  },
  [PARTNER_STATUS_VALUES.PENDING]: {
    label: 'Pending',
    chipBackgroundColor: 'rgba(237, 108, 2, 0.12)',
    chipColor: '#ed6c02',
  },
  [PARTNER_STATUS_VALUES.REJECTED]: {
    label: 'Rejected',
    chipBackgroundColor: 'rgba(211, 47, 47, 0.12)',
    chipColor: '#d32f2f',
  },
};

export const normalizePartnerStatus = (status) => {
  const normalized = String(status ?? '')
    .trim()
    .toLowerCase();
  return PARTNER_STATUS_SET.has(normalized) ? normalized : null;
};

export const resolvePartnerStatus = (partner, fallbackStatus) =>
  normalizePartnerStatus(partner?.status ?? fallbackStatus);

export const isPartnerLiveStatus = (status) =>
  normalizePartnerStatus(status) === PARTNER_STATUS_VALUES.LIVE;

export const getPartnerStatusMeta = (status) => {
  const normalized = normalizePartnerStatus(status);
  if (normalized) {
    return PARTNER_STATUS_STYLES[normalized];
  }
  return {
    label: status ? String(status) : 'Unknown',
    chipBackgroundColor: 'rgba(117, 117, 117, 0.12)',
    chipColor: '#757575',
  };
};

export const NON_LIVE_PARTNER_CELL_SX = {
  opacity: 0.45,
  pointerEvents: 'none',
  userSelect: 'none',
};
